import React from "react";
import { EditFieldBox } from "../../containers";

export const EditFieldPage = () => {
  return (
    <div>
      <EditFieldBox />
    </div>
  );
};
